export interface User {
  userId: string | null;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ADUserName: string;
  auth0UserId: string;
  hrRef: number | null;
  isActive: boolean;
  modifiedBy: string | null;
  modifiedDate: string | null;
  userName: string;
  cellPhone: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  SMSLinked: boolean | null;
  proxyHRRef: number | null;
  proxyHRRefs: string;
  auth0SMSId: string;
  notes: string;
  employeeID: string | null;
  active: boolean;
  absorbDateUpdated: string | null;
  fullName: string | null;
  vpCompanyID: number | null;
}
